'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _style = require('styled-jsx/style');

var _style2 = _interopRequireDefault(_style);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _TwitterDetails = require('./TwitterDetails.css');

var _TwitterDetails2 = _interopRequireDefault(_TwitterDetails);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TwitterDetails = function TwitterDetails(props) {
  return _react2.default.createElement(
    'div',
    {
      className: 'jsx-' + _TwitterDetails2.default.__scopedHash + ' ' + ('twitterDetails ' + (props.isLarge ? 'isLarge' : ''))
    },
    _react2.default.createElement(
      'a',
      { href: props.profileUrl, target: '_blank', rel: 'noopener noreferrer', className: 'jsx-' + _TwitterDetails2.default.__scopedHash
      },
      _react2.default.createElement('img', { src: props.profileImageUrl, alt: '', className: 'jsx-' + _TwitterDetails2.default.__scopedHash + ' ' + 'profileImage'
      })
    ),
    _react2.default.createElement(
      'a',
      { href: props.url, target: '_blank', rel: 'noopener noreferrer', className: 'jsx-' + _TwitterDetails2.default.__scopedHash
      },
      _react2.default.createElement(
        'div',
        {
          className: 'jsx-' + _TwitterDetails2.default.__scopedHash + ' ' + 'author'
        },
        _react2.default.createElement(
          'div',
          {
            className: 'jsx-' + _TwitterDetails2.default.__scopedHash + ' ' + 'authorName'
          },
          props.authorName
        ),
        props.verified && _react2.default.createElement('div', {
          className: 'jsx-' + _TwitterDetails2.default.__scopedHash + ' ' + 'verifiedIcon'
        }),
        _react2.default.createElement(
          'div',
          {
            className: 'jsx-' + _TwitterDetails2.default.__scopedHash + ' ' + 'authorHandle'
          },
          props.authorHandle
        )
      )
    ),
    _react2.default.createElement(_style2.default, {
      styleId: _TwitterDetails2.default.__scopedHash,
      css: _TwitterDetails2.default.__scoped
    })
  );
};

TwitterDetails.propTypes = {
  isLarge: _propTypes2.default.bool.isRequired,
  profileUrl: _propTypes2.default.string.isRequired,
  profileImageUrl: _propTypes2.default.string.isRequired,
  url: _propTypes2.default.string.isRequired,
  verified: _propTypes2.default.bool.isRequired,
  authorHandle: _propTypes2.default.string.isRequired,
  authorName: _propTypes2.default.string.isRequired

};

TwitterDetails.displayName = 'TwitterDetails';

exports.default = TwitterDetails;